import React from 'react';

// Libraries
import classNames from 'classnames';

// Types
import Dictionary from '@/types/dictionary';
import Locale from '@/types/locale';
import LocalizedString from '@/types/localized-string';

// Utils
import { formatLocalizedString, formatMessage, formatMessageWithLocale } from '@/utils/i18n';

export enum ALLOWED_HTML_TAGS {
  DIV = 'div',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
  P = 'p',
  SPAN = 'span',
}

type Props = {
  className?: string;
  defaultMessage?: string;
  icon?: string;
  locale?: Locale;
  tagName?: ALLOWED_HTML_TAGS;
  toLocalize: string | LocalizedString;
  values?: Dictionary<string | number>;
};

const FormattedMessageV2 = (props: Props) => {
  const { className, defaultMessage, icon, locale, tagName, toLocalize, values, ...formattedMessageProps } = props;

  // Variables
  const CustomTag = (tagName || ALLOWED_HTML_TAGS.DIV) as keyof JSX.IntrinsicElements;
  let formattedText = '';

  if (typeof toLocalize === 'object') {
    formattedText = formatLocalizedString(toLocalize);
  } else {
    formattedText = locale ? formatMessageWithLocale(toLocalize, locale, values, defaultMessage) : formatMessage(toLocalize, values, defaultMessage);
  }

  return (
    <CustomTag className={classNames('formatted-message-v2', className)} {...formattedMessageProps}>
      {icon && <i className={`icon-${icon}`} />}
      {formattedText}
    </CustomTag>
  );
};

export default FormattedMessageV2;
